import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import CustomerDataFoundationImage from './CustomerDataFoundationImage'

const copy = {
  heading: `Establish a customer data foundation`,
  description: `Intelligent customer engagement and AI models are only as good as the quality of your data. Collect, clean, and activate AI-ready data.`,
}

const link = {
  text: `Explore Connections`,
  url: `/product/connections/`,
}

const CustomerDataFoundation = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionBase variant="2Col">
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </SectionCopy>
      <Section.Contents>
        <CustomerDataFoundationImage />
      </Section.Contents>
    </SectionBase>
  )
}

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default CustomerDataFoundation
